import React from "react";
import { TextField, MenuItem } from "@mui/material";

import {
  EventContainer,
  FormGrid,
  Card,
  CardTitle,
  InputGroup,
  InputLabel,
  Textarea,
  TagsSection,
  Tag,
} from "./styles";

export default function DetalhesConquista({ conquistaData = {}, setConquistaData }) {
  const tagColors = {
    Educação: "#6366F1",
    Engajamento: "#10B981",
    Eventos: "#F59E0B",
    Cursos: "#2563EB",
    Oportunidades: "#9333EA",
    Tecnologia: "#1D4ED8",
    IA: "#7E22CE",
  };

  const tipos = ["EVENTO", "CURSO", "OPORTUNIDADE"];
  const acoes = [
  "INSCRICAO",
  "CURTIR",
  "LEMBRAR",
  "CHECKIN"
];

  const toggleTag = (tag) => {
    const newTags = conquistaData.tags?.includes(tag)
      ? conquistaData.tags.filter((t) => t !== tag)
      : [...(conquistaData.tags || []), tag];

    setConquistaData({ ...conquistaData, tags: newTags });
  };

  const criterio = conquistaData.criterioDesbloqueio || {};

  return (
    <EventContainer>
      <FormGrid>
        {/* DETALHES PRINCIPAIS */}
        <Card style={{ gridColumn: "1 / 3" }}>
          <CardTitle>Detalhes da Conquista</CardTitle>

          <InputGroup>
            <InputLabel>Título da Conquista *</InputLabel>
            <TextField
              placeholder="Ex: Explorador de Eventos"
              fullWidth
              value={conquistaData.titulo || ""}
              onChange={(e) =>
                setConquistaData({ ...conquistaData, titulo: e.target.value })
              }
            />
          </InputGroup>

          <InputGroup>
            <InputLabel>Descrição *</InputLabel>
            <Textarea
              placeholder="Descreva o que o usuário precisa fazer"
              value={conquistaData.descricao || ""}
              onChange={(e) =>
                setConquistaData({ ...conquistaData, descricao: e.target.value })
              }
            />
          </InputGroup>

          <InputGroup>
            <InputLabel>XP concedido</InputLabel>
            <TextField
              type="number"
              fullWidth
              value={conquistaData.xp || 0}
              onChange={(e) =>
                setConquistaData({
                  ...conquistaData,
                  xp: Number(e.target.value),
                })
              }
            />
          </InputGroup>

          <InputGroup style={{ marginTop: "12px" }}>
            <label style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <input
                type="checkbox"
                checked={conquistaData.ativa || false}
                onChange={(e) =>
                  setConquistaData({
                    ...conquistaData,
                    ativa: e.target.checked,
                  })
                }
              />
              <span>Conquista ativa</span>
            </label>
          </InputGroup>
        </Card>

        {/* TAGS */}
        <Card style={{ gridColumn: "1 / 3" }}>
          <InputGroup>
            <InputLabel>Tags</InputLabel>
            <TagsSection>
              {Object.keys(tagColors).map((tag) => {
                const isActive = conquistaData.tags?.includes(tag);
                return (
                  <Tag
                    key={tag}
                    style={{
                      backgroundColor: isActive ? tagColors[tag] : "#ebeef2",
                      color: isActive ? "#fff" : "#566474",
                    }}
                    onClick={() => toggleTag(tag)}
                  >
                    {tag}
                  </Tag>
                );
              })}
            </TagsSection>
          </InputGroup>
        </Card>

        {/* CRITÉRIO DE DESBLOQUEIO */}
        <Card style={{ gridColumn: "1 / 3" }}>
          <CardTitle>Critério de Desbloqueio</CardTitle>

          <FormGrid columns="3">
            <InputGroup>
              <InputLabel>Tipo</InputLabel>
              <TextField
                select
                fullWidth
                value={criterio.tipo || ""}
                onChange={(e) =>
                  setConquistaData({
                    ...conquistaData,
                    criterioDesbloqueio: {
                      ...criterio,
                      tipo: e.target.value,
                    },
                  })
                }
              >
                {tipos.map((t) => (
                  <MenuItem key={t} value={t}>
                    {t}
                  </MenuItem>
                ))}
              </TextField>
            </InputGroup>

            <InputGroup>
              <InputLabel>Ação</InputLabel>
              <TextField
                select
                fullWidth
                value={criterio.acao || ""}
                onChange={(e) =>
                  setConquistaData({
                    ...conquistaData,
                    criterioDesbloqueio: {
                      ...criterio,
                      acao: e.target.value,
                    },
                  })
                }
              >
                {acoes.map((a) => (
                  <MenuItem key={a} value={a}>
                    {a}
                  </MenuItem>
                ))}
              </TextField>
            </InputGroup>

            <InputGroup>
              <InputLabel>Quantidade</InputLabel>
              <TextField
                type="number"
                fullWidth
                value={criterio.quantidade || ""}
                onChange={(e) =>
                  setConquistaData({
                    ...conquistaData,
                    criterioDesbloqueio: {
                      ...criterio,
                      quantidade: Number(e.target.value),
                    },
                  })
                }
              />
            </InputGroup>
          </FormGrid>
        </Card>
      </FormGrid>
    </EventContainer>
  );
}
